import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import SubjectToolkit from './subjectToolKitTab';
import Assignments from './Assignments';
import Details from './Details';
import CRFSTab from './CRFSTab';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setActiveStep, setCurrentPatientTrailTab } from 'src/store/SelectedIntrialPatient';
import { useGetAllcodelistDataQuery } from 'src/services/codeList';
import { setCodelistData } from 'src/store/codelistData';

const PatientTrailNoteBookTabs: React.FC<any> = ({ parent_id, prescreen_id, actionConfiguredFormsSteps }) => {
  const tabpanelData = [
    { value: '1', cmp: SubjectToolkit, label: 'Subject Toolkit' },
    { value: '2', cmp: Assignments, label: 'Assignments' },
    { value: '3', cmp: Details, label: 'Details' },
    { value: '4', cmp: CRFSTab, label: 'CRFS' }
  ];
  const {
    data: getAllCodelistData,
    isLoading: getAllCodelistIsLoading,
    isError: getAllCodelistIsError,
    isSuccess: getAllCodelistIsSuccess
  } = useGetAllcodelistDataQuery();
  const selectedSubjectInfo = useAppSelector(state => state.selectedSubjectInfo);
  const dispatch = useAppDispatch();
  const currentPatientTrailTab = useAppSelector(state => state.SelectedIntrialPatientInfo.currentPatientTrailTab);
  const plannedDate = useAppSelector(state => state.SelectedIntrialPatientInfo.plannedDate);
  const [value, setValue] = useState('');
  const handleChangeTabs = (_: React.SyntheticEvent, newValue: any) => {
    setValue(newValue);
    dispatch(setCurrentPatientTrailTab(newValue));
  };
  useEffect(() => {
    plannedDate != null ? dispatch(setActiveStep(1)) : dispatch(setActiveStep(0));
  }, [plannedDate]);
  useEffect(() => {
    if (selectedSubjectInfo?.selected_crf) {
      setValue('4');
    } else {
      setValue(currentPatientTrailTab);
    }
  }, [currentPatientTrailTab]);
  useEffect(() => {
    if (getAllCodelistData && getAllCodelistIsSuccess && !getAllCodelistIsError && !getAllCodelistIsLoading) {
      dispatch(setCodelistData(getAllCodelistData));
    }
  }, [getAllCodelistData, getAllCodelistIsLoading, getAllCodelistIsError, getAllCodelistIsSuccess]);
  return (
    <div>
      <TabContext value={value}>
        <TabList
          onChange={handleChangeTabs}
          aria-label="TSDA Patients Notebook Tabs"
          className="tabsFontSize extendedTabs2"
        >
          {tabpanelData.map((tab, index) => (
            <Tab
              sx={{ marginLeft: '-15px' }}
              label={tab.label}
              value={tab.value}
              key={index}
              disabled={tab.value == '4' && actionConfiguredFormsSteps < 2}
            />
          ))}
        </TabList>
        {tabpanelData.map(tab => (
          <TabPanel value={tab.value} sx={{ p: 0, position: 'relative' }} key={tab.value}>
            <tab.cmp
              parent_id={parent_id}
              prescreen_id={prescreen_id}
              actionConfiguredFormsSteps={actionConfiguredFormsSteps}
            />
          </TabPanel>
        ))}
      </TabContext>
    </div>
  );
};

export default PatientTrailNoteBookTabs;
